import React from 'react';
import Loading from 'react/components/Loading/Loading';

function QuickAssignmentAssignLoading({ name, shouldShow = false }) {
  if (!shouldShow) return null;

  return (
    <div data-testid="assign-loading" className="assign-driver-loading">
      <div>
        <p data-testid="assign-loading-name">{name}</p>
      </div>
      <Loading width='20px' height='20px' />
    </div>
  );
}

export default QuickAssignmentAssignLoading;
